import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { PinManagerService } from 'src/app/services/pin-manager.service';
import { SampleService } from 'src/app/services/sample.service';
import { NewDeletePinComponent } from '../pin-rework-dialogs/new-delete-pin/new-delete-pin.component';

@Component({
    selector: 'app-delete-sample',
    templateUrl: './delete-sample.component.html',
    styleUrls: ['./delete-sample.component.css'],
    standalone: false
})
export class DeleteSampleComponent {

  sampleId:number = this.data.sampleId;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public deleteSampleDialog: MatDialogRef<DeleteSampleComponent>,
      private sampleService: SampleService,
      public nav: NavBarComponent,
      private pinManagerService: PinManagerService,
  ) {
  }


  close(): void {
    this.deleteSampleDialog.close();
  }
  deleteSample(){
    this.nav.toggleLoading(true);

    this.sampleService.deleteSampleById(this.sampleId).pipe(
        catchError(error => {
          console.error(error);
          return throwError(() => error);
        })
    ).subscribe(() => {
      this.deleteSampleDialog.close();
      this.nav.toggleLoading(false);
    });
  }
}
